export default class TextInput {
	constructor (samples) {
		this.samples = samples;

		this.type = "text"
	}
}